module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Medium.eot
// module id = 14
// module chunks = 8